import { Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { $crud } from "../../utils/CrudFactory";

const PieChart = ({ apiEndpoint, title }) => {
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await $crud.retrieve(apiEndpoint);
        const data = res.data || {};

        let value = 0;
        if (title === "Customer Growth")
          value = parseFloat(data.customerGrowth) || 0;
        if (title === "Drivers Growth")
          value = parseFloat(data.driverGrowth) || 0;
        if (title === "Revenue Growth")
          value = parseFloat(data.revenueGrowth) || 0;

        setPercentage(value);
      } catch (err) {
        console.error("Error fetching PieChart data:", err);
      }
    };

    fetchData();
  }, [title, apiEndpoint]);

  const remaining = 100 - percentage;

  const chartOptions = {
    chart: { type: "donut" },
    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: {
          size: "55%",
          labels: {
            show: true,
            name: { show: false },
            total: {
              show: true,
              showAlways: true,
              formatter: function (w) {
                return w.globals.series[0].toFixed(0) + "%";
              },
              style: {
                fontSize: "20px",
                fontWeight: 700,
                color: "rgba(104, 60, 140, 1)",
              },
            }
          }
        }
      }
    },
    dataLabels: { enabled: false },
    tooltip: { enabled: false },
    colors: ["rgba(104, 60, 140, 1)", "rgba(104, 60, 140, 0.35)"],
    legend: { show: false },
    stroke: { width: 0 },
  };

  return (
    <div style={{ width: "200px", height: "200px", position: "relative" }}>
      <ReactApexChart
        key={title + percentage}
        options={chartOptions}
        series={[percentage, remaining]}
        type="donut"
        width="100%"
        height="100%"
      />
      <Typography
        sx={{
          textAlign: "center",
          fontSize: "12px",
          color: "#683C8C",
          fontWeight: 600,
          // marginTop: "-15px",
        }}
      >
        {title}
      </Typography>
    </div>
  );
};

export default PieChart;